/* Aroma Deal Days runtime. Loaded (deferred) only while the event is on (snippets/ap-deal-days-head.liquid).
   - One 1s interval drives every [data-ap-dd-countdown] to the shopper's next LOCAL midnight (refreshes daily,
     owner 2026-10-04), capped at the real end epoch window.APDD.end, which alone decides when the event is over.
     At the deadline: html.ap-dd-on -> html.ap-dd-over (every chip reverts, [data-dd] hides; homepage reloads once).
   - APDD.track(): the single analytics helper. Pushes dataLayer events with one schema
     {event, dd_skin, dd_accent, ...payload}. Event names live in NAMES only (one-line renames).
   - Add-to-cart layer: "Deal Days price" ribbon on the main PDP button, press/success feedback after a real
     /cart/add (fetch or XHR), Ajax upgrade of the hub/home card quick-add forms, and a mobile sticky ATC on product
     pages that have none of their own. Never changes PDP markup it does not own; never touches selling plans. */
(function () {
  'use strict';
  var cfg = window.APDD || {};
  var i18n = {};
  (function () { var el = document.createElement('textarea'); var src = cfg.i18n || {}; Object.keys(src).forEach(function (k) { el.innerHTML = String(src[k]); i18n[k] = el.value; }); }());
  var endMs = (Number(cfg.end) || 0) * 1000;
  var root = document.documentElement;
  var timer = null;

  /* ---------------- analytics (docs/research/prime-sale-2026/06-measurement-plan.md section 4) ----------------
     One helper, three sinks: GA4 direct gtag (send_to G-BWV3G4G3PQ, the proven ap-cro-observer route; GTM runs in a
     sandboxed pixel so dataLayer pushes never reach it), window.__APEvent (OpenReplay + PostHog via the layout
     allowlist), and nothing else. Event names live in NAMES only. Skips automation and owner/QA traffic, but always
     records to window.APDD.events so QA can assert what WOULD have been sent. No PII, strings <= 100 chars. */
  var GA4_ID = 'G-BWV3G4G3PQ';
  var NAMES = {
    exposure: 'dd_exposure',
    bar_click: 'dd_bar_click',
    hero_click: 'dd_hero_click',
    hub_tile_click: 'dd_hub_tile_click',
    countdown_view: 'dd_countdown_view',
    pill_click: 'dd_pill_click',
    atc: 'dd_atc',
    ladder_view: 'dd_ladder_view',
    ladder_progress: 'dd_ladder_progress',
    gift_unlocked: 'dd_gift_unlocked',
    gift_removed: 'dd_gift_removed',
    checkout_click: 'dd_checkout_click'
  };
  var gaQueue = [];
  cfg.events = [];
  function suppressed() {
    return !(window.apAnalyticsEligibility && window.apAnalyticsEligibility.current().eligible) || navigator.webdriver === true || /bot|crawl|spider|headless|lighthouse|pagespeed/i.test(navigator.userAgent || '') || window.__AP_OWNER_TRAFFIC === true;
  }
  function flushGa() {
    if (suppressed()) { gaQueue = []; return; }
    if (document.readyState !== 'complete') return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    while (gaQueue.length) { var e = gaQueue.shift(); try { window.gtag('event', e[0], e[1]); } catch (err) { /* never break the page */ } }
  }
  window.addEventListener('load', flushGa);
  if (window.apAnalyticsEligibility) window.apAnalyticsEligibility.subscribe(function(state){ if (!state.eligible) gaQueue = []; });
  function track(key, params) {
    var name = NAMES[key] || key;
    var payload = { dd_skin: cfg.skin || 'amalfi', dd_accent: cfg.accent || '', dd_exp: cfg.exp || 'none', page_type: cfg.pageType || '', device_type: window.innerWidth < 750 ? 'mobile' : 'desktop' };
    Object.keys(params || {}).forEach(function (k) {
      var v = params[k];
      if (v == null || v === '') return;
      payload[k] = typeof v === 'string' ? v.slice(0, 100) : v;
    });
    if (window.apAnalyticsEligibility) Object.assign(payload, window.apAnalyticsEligibility.properties());
    cfg.events.push([name, payload]);
    if (suppressed()) return payload;
    var ga = { send_to: GA4_ID };
    Object.keys(payload).forEach(function (k) { ga[k] = payload[k]; });
    gaQueue.push([name, ga]);
    flushGa();
    try { if (typeof window.__APEvent === 'function') window.__APEvent(name, payload); } catch (e) { /* ignore */ }
    return payload;
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var el = event.target.closest('[data-dd-track]');
    if (el) {
      var key = el.getAttribute('data-dd-track');
      if (key === 'hub_tile_click') track(key, { dd_tile: el.getAttribute('data-dd-tile'), dd_section: el.getAttribute('data-dd-section'), dd_position: Number(el.getAttribute('data-dd-position')) || undefined });
      else track(key, { dd_cta: el.getAttribute('data-dd-cta') });
    }
    var pill = event.target.closest('.apgp-card, .pcard, .ap-recs__card, .card-wrapper');
    if (pill) {
      var chip = pill.querySelector('.apgp-badge--off, .pcard__badge--sale, .ap-recs__badge--sale, .ap-dd-pill__pct');
      if (chip) track('pill_click', { dd_surface: pill.classList.contains('pcard') ? 'home' : pill.classList.contains('ap-recs__card') ? 'recs' : 'card', dd_pct: Math.abs(parseInt(chip.textContent.replace(/[^0-9-]/g, ''), 10)) || undefined });
    }
    var checkout = event.target.closest('.ap-cart__checkout, [data-ap-cart-checkout-plus], [data-ap-cart-checkout-without], .cart__checkout-button, #checkout');
    if (checkout) {
      var tierState = document.querySelector('[data-dd-ladder-tier]');
      track('checkout_click', { dd_surface: checkout.closest('[data-ap-cart]') ? 'drawer' : 'cart_page', dd_tier_state: tierState ? tierState.getAttribute('data-dd-ladder-tier') : undefined });
    }
  }, true);

  /* ---------------- countdown + expiry ---------------- */
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  // Daily countdown: to the next local midnight in the shopper's own timezone, never past the real end.
  function nextLocalMidnight(now) { var m = new Date(now); m.setHours(24, 0, 0, 0); return m.getTime(); }
  function remaining() {
    var now = Date.now();
    var ms = Math.max(0, Math.min(nextLocalMidnight(now), endMs) - now);
    var s = Math.floor(ms / 1000);
    return { ended: now >= endMs, d: 0, h: Math.floor(s / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }
  function shortLeft(t) { return t.d > 0 ? t.d + 'd ' + pad(t.h) + 'h' : pad(t.h) + 'h ' + pad(t.m) + 'm'; }

  function expire() {
    root.classList.remove('ap-dd-on');
    root.classList.add('ap-dd-over');
    if (document.querySelector('[data-dd-hero]')) {
      try {
        if (!sessionStorage.getItem('apDdReloaded')) { sessionStorage.setItem('apDdReloaded', '1'); window.location.reload(); }
      } catch (e) { /* storage blocked: [data-dd] is already hidden */ }
    }
  }
  /* Split-flap tile: replay the flip on each change (departure-board bar). */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function flip(tile) {
    if (!tile || !tile.classList) return;
    tile.classList.remove('is-flip');
    void tile.offsetWidth;
    tile.classList.add('is-flip');
  }

  /* Departure board: one real deal at a time; flips every 4.2s, pauses on hover/focus or a hidden tab.
     Only the visible deal is focusable / exposed to assistive tech. Reduced motion: advances without motion. */
  function setupBoard() {
    var boards = document.querySelectorAll('[data-ap-dd-board]');
    Array.prototype.forEach.call(boards, function (board) {
      var items = board.querySelectorAll('.ap-dd-board__it');
      if (items.length < 2) return;
      var i = 0;
      var paused = false;
      function show(next) {
        var cur = items[i];
        var nxt = items[next];
        cur.classList.remove('is-on');
        cur.classList.add('is-out');
        cur.setAttribute('aria-hidden', 'true');
        cur.querySelector('a').setAttribute('tabindex', '-1');
        window.setTimeout(function () { cur.classList.remove('is-out'); }, 520);
        nxt.classList.add('is-on');
        nxt.removeAttribute('aria-hidden');
        nxt.querySelector('a').removeAttribute('tabindex');
        i = next;
      }
      board.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') paused = true; });
      board.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') paused = false; });
      board.addEventListener('focusin', function () { paused = true; });
      board.addEventListener('focusout', function () { paused = false; });
      window.setInterval(function () {
        if (paused || document.hidden) return;
        show((i + 1) % items.length);
      }, 4200);
    });
  }
  function paint(el, t) {
    el.classList.toggle('is-ended', t.ended);
    var parts = { d: t.d, h: pad(t.h), m: pad(t.m), s: pad(t.s) };
    var targets = el.querySelectorAll('[data-dd-part]');
    var flaps = el.hasAttribute('data-dd-flap') && !reduceMotion;
    for (var i = 0; i < targets.length; i += 1) {
      var key = targets[i].getAttribute('data-dd-part');
      var value = key === 'd' && el.hasAttribute('data-dd-pad-days') ? pad(parts.d) : String(parts[key]);
      if (targets[i].textContent !== value) {
        targets[i].textContent = value;
        if (flaps) flip(targets[i].parentNode);
      }
    }
  }
  function tick() {
    if (!endMs) return;
    var t = remaining();
    var els = document.querySelectorAll('[data-ap-dd-countdown]');
    for (var i = 0; i < els.length; i += 1) paint(els[i], t);
    paintRibbons(t);
    paintSticky(t);
    if (t.ended) {
      if (timer) { window.clearInterval(timer); timer = null; }
      expire();
    }
  }

  /* dd_exposure: first event-chrome sighting per session (experiment denominator). */
  function exposure(surface) {
    try { if (sessionStorage.getItem('apDdExposed')) return; sessionStorage.setItem('apDdExposed', '1'); } catch (e) { /* still send once per page */ }
    track('exposure', { dd_entry: cfg.pageType || '', dd_surface: surface });
  }
  /* countdown_view: once per page, when a countdown is at least half visible. */
  function watchCountdownView() {
    if (!('IntersectionObserver' in window)) return;
    var seen = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (seen || !entry.isIntersecting) return;
        seen = true;
        var surface = entry.target.closest('.ap-dd-bar') ? 'bar' : entry.target.closest('.ap-dd-hero') ? (entry.target.closest('.ap-dd-hub') ? 'hub' : 'hero') : entry.target.closest('.ap-dd-strip') ? (/\/products\//.test(location.pathname) ? 'pdp' : /\/cart/.test(location.pathname) ? 'cart' : 'strip') : 'other';
        track('countdown_view', { dd_surface: surface, dd_hours_left: Math.floor(Math.max(0, endMs - Date.now()) / 3600000) });
        exposure(surface);
        io.disconnect();
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.ap-dd-hero [data-ap-dd-countdown], .ap-dd-bar [data-ap-dd-countdown], .ap-dd-strip [data-ap-dd-countdown]').forEach(function (el) { io.observe(el); });
  }

  /* ---------------- add-to-cart layer ---------------- */
  var MAIN_ATC = '[data-ap-atc], .ap-sv2__atc, .product-form__submit';
  var ATC_SURFACES = [
    { sel: '.ap-dd-sticky__btn', surface: 'sticky' },
    { sel: '[class*="__mobile-bar"] button', surface: 'sticky' },
    { sel: '[data-ap-sticky-add], [data-ap-hd-sticky-add]', surface: 'sticky' },
    { sel: MAIN_ATC, surface: 'pdp' },
    { sel: '.apgp-add, .pcard__cta', surface: 'quick_add' },
    { sel: '.ap-recs__picker-add', surface: 'recs' },
    { sel: '[data-dd-atc="card"]', surface: 'hub' },
    { sel: '.bb-purchase__cta, .bb-rail__cta, .bb-peek__cta, [class*="builder"] button', surface: 'builder' }
  ];
  var lastAtc = null;
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    for (var i = 0; i < ATC_SURFACES.length; i += 1) {
      var el = event.target.closest(ATC_SURFACES[i].sel);
      if (el) { lastAtc = { el: el, surface: ATC_SURFACES[i].surface, at: Date.now() }; return; }
    }
  }, true);

  function productHandle(el) {
    var card = el && el.closest('[data-product], [data-handle], [data-product-handle]');
    if (card) return card.getAttribute('data-product') || card.getAttribute('data-handle') || card.getAttribute('data-product-handle');
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }
  function variantFromBody(body) {
    try {
      if (!body) return '';
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') { var j = JSON.parse(body); return String((j.items && j.items[0] && j.items[0].id) || j.id || ''); }
        var p = new URLSearchParams(body); return p.get('id') || '';
      }
      if (body instanceof FormData) return String(body.get('id') || '');
    } catch (e) { /* ignore */ }
    return '';
  }
  function money(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', currencyDisplay: 'narrowSymbol' }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  var ribbonFlash = 0;
  function ribbonText(t) { return (i18n.dealPrice || 'Prime Week price') + ' · ' + (i18n.endsIn || 'Ends in') + ' ' + shortLeft(t); }
  function ensureRibbons() {
    if (!/\/products\//.test(location.pathname)) return;
    document.querySelectorAll(MAIN_ATC).forEach(function (btn) {
      if (btn.closest('[class*="__mobile-bar"]') || btn.disabled || btn.querySelector('.ap-dd-atc-ribbon')) return;
      if (btn.offsetWidth < 160) return;
      var r = document.createElement('span');
      r.className = 'ap-dd-atc-ribbon';
      r.setAttribute('aria-hidden', 'true');
      r.innerHTML = '<svg viewBox="0 0 24 24"><use href="#ap-dd-mark"/></svg><span></span>';
      btn.appendChild(r);
    });
  }
  function paintRibbons(t) {
    ensureRibbons();
    if (Date.now() < ribbonFlash) return;
    var txt = ribbonText(t);
    document.querySelectorAll('.ap-dd-atc-ribbon').forEach(function (r) {
      r.classList.remove('is-added');
      var s = r.querySelector('span');
      if (s && s.textContent !== txt) s.textContent = txt;
    });
  }

  /* After a successful add: pulse the button, flash the ribbon with gift progress, fire dd_atc. */
  function afterAdd(body) {
    var ctx = lastAtc && Date.now() - lastAtc.at < 15000 ? lastAtc : null;
    track('atc', { dd_surface: ctx ? ctx.surface : 'other', product: productHandle(ctx && ctx.el), variant: variantFromBody(body) });
    if (ctx && ctx.el) {
      ctx.el.classList.remove('ap-dd-just-added');
      void ctx.el.offsetWidth;
      ctx.el.classList.add('ap-dd-just-added');
      setTimeout(function () { ctx.el.classList.remove('ap-dd-just-added'); }, 900);
    }
    if (!cfg.gift || !window.APDDGifts) return;
    window.APDDGifts.progress().then(function (p) {
      if (!p) return;
      var msg;
      if (p.tier === 'gold') msg = i18n.goldUnlocked || 'Gold Mystery Gift unlocked';
      else if (p.tier === 'silver') msg = (i18n.toGold || 'Added · __AMOUNT__ to your Gold Mystery Gift').replace('__AMOUNT__', money(p.toGold));
      else msg = (i18n.toSilver || 'Added · __AMOUNT__ to your Silver Mystery Gift').replace('__AMOUNT__', money(p.toSilver));
      ribbonFlash = Date.now() + 5000;
      document.querySelectorAll('.ap-dd-atc-ribbon').forEach(function (r) { r.classList.add('is-added'); var s = r.querySelector('span'); if (s) s.textContent = msg; });
    });
  }

  function isAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); }
  (function patchNetwork() {
    if (window.__apDdNetPatched) return;
    window.__apDdNetPatched = true;
    var nativeFetch = window.fetch;
    if (nativeFetch) {
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var result = nativeFetch.apply(this, arguments);
        if (isAdd(url)) result.then(function (res) { if (res && res.ok) afterAdd(init && init.body); }).catch(function () {});
        return result;
      };
    }
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) { this.__apDdUrl = url; return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      if (isAdd(this.__apDdUrl)) this.addEventListener('loadend', function () { if (this.status >= 200 && this.status < 300) afterAdd(body); });
      return send.apply(this, arguments);
    };
  }());

  /* Hub/home deal cards: real <form action="/cart/add">; upgrade to Ajax so the drawer opens in place. */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form[data-dd-quickadd]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    var btn = form.querySelector('button');
    if (btn) { btn.disabled = true; lastAtc = { el: btn, surface: 'hub', at: Date.now() }; }
    var body = JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] });
    window.fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); if (window.apCartDrawer && window.apCartDrawer.open) window.apCartDrawer.open(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  /* ---------------- mobile sticky ATC (only where a product page has none) ---------------- */
  var sticky = null;
  var stickyTarget = null;
  function priceText() {
    var el = document.querySelector('[data-ap-price], [data-ap-hd-price], .ap-cro__price strong, .price__sale .price-item--sale, .price__regular .price-item--regular, [data-ap-sv2-price]');
    return el ? el.textContent.trim().split('\n')[0] : '';
  }
  function setupSticky() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('[class*="__mobile-bar"], [class*="sticky-atc"], [class*="sticky-bar"]')) return;
    stickyTarget = document.querySelector(MAIN_ATC);
    if (!stickyTarget || !('IntersectionObserver' in window)) return;
    sticky = document.createElement('div');
    sticky.className = 'ap-dd-sticky';
    sticky.setAttribute('data-dd', '');
    sticky.innerHTML = '<div class="ap-dd-sticky__info"><span class="ap-dd-sticky__price"></span><span class="ap-dd-sticky__time"></span></div><button type="button" class="ap-dd-sticky__btn"></button>';
    sticky.querySelector('button').textContent = i18n.sticky || 'Add to cart';
    sticky.querySelector('button').addEventListener('click', function () { if (stickyTarget && !stickyTarget.disabled) stickyTarget.click(); });
    document.body.appendChild(sticky);
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      sticky.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0 && !stickyTarget.disabled);
    }).observe(stickyTarget);
  }
  function paintSticky(t) {
    if (!sticky) return;
    var p = priceText();
    var pe = sticky.querySelector('.ap-dd-sticky__price');
    if (pe.textContent !== p) pe.textContent = p;
    var te = sticky.querySelector('.ap-dd-sticky__time');
    var tt = (i18n.endsIn || 'Ends in') + ' ' + shortLeft(t);
    if (te.textContent !== tt) te.textContent = tt;
  }

  /* ---------------- cart drawer event layer (v26 calls APDDCart.decorate after each render) ----------------
     Compact countdown pill beside the cart title, compare-at "Was" price + Prime Week chip on discounted lines, and a
     savings row above the subtotal. Compare-at comes from /products/<handle>.js (cart JSON has none), cached
     per handle for the page. Gift lines, $0 lines and lines without a real compare-at are left untouched. */
  var cmpCache = {};
  var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function fmtMoney(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', currencyDisplay: 'narrowSymbol' }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function compareMap(handle) {
    if (!cmpCache[handle]) {
      cmpCache[handle] = window.fetch(shopRoot + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { var m = {}; ((p && p.variants) || []).forEach(function (v) { m[v.id] = Number(v.compare_at_price || 0); }); return m; })
        .catch(function () { return {}; });
    }
    return cmpCache[handle];
  }
  function decorateCart(drawer, cart) {
    if (!drawer || !cart || !root.classList.contains('ap-dd-on')) return;
    // Owner 2026-10-03: no countdown at the top of the cart (the bar carries the timer); clear any earlier pill.
    var oldPill = drawer.querySelector('.ap-dd-cartpill');
    if (oldPill) oldPill.remove();
    var items = cart.items || [];
    var handles = {};
    items.forEach(function (it) { if (it.handle && Number(it.final_line_price || 0) > 0) handles[it.handle] = true; });
    Promise.all(Object.keys(handles).map(function (h) { return compareMap(h).then(function (m) { return [h, m]; }); })).then(function (pairs) {
      var maps = {};
      pairs.forEach(function (p) { maps[p[0]] = p[1]; });
      var saved = 0;
      items.forEach(function (it) {
        var final = Number(it.final_line_price || 0);
        if (final <= 0) return;
        var cmpEach = (maps[it.handle] || {})[it.variant_id] || 0;
        var cmpLine = cmpEach * Number(it.quantity || 0);
        var original = Number(it.original_line_price || 0);
        var ref = Math.max(cmpLine, original);
        if (ref > final) saved += ref - final;
        // Bundle Builder lines are one snapshot product priced at the bundle total (no compare-at); the builder records
        // its own saving vs the items bought separately in _bundle_saved (per bundle, in dollars). Live QA 2026-10-03.
        var bSaved = it.properties && Number(it.properties._bundle_saved);
        if (bSaved > 0 && ref <= final) saved += Math.round(bSaved * 100) * Number(it.quantity || 1);
        if (cmpLine <= original) return;
        var row = drawer.querySelector('[data-ap-cart-line="' + (window.CSS && CSS.escape ? CSS.escape(it.key) : it.key) + '"] .ap-cart__price-row');
        if (!row || row.querySelector('.ap-dd-cartwas')) return;
        var existing = row.querySelector('.ap-cart__compare');
        if (existing) existing.remove();
        var was = document.createElement('span');
        was.className = 'ap-cart__compare ap-dd-cartwas';
        was.textContent = fmtMoney(cmpLine);
        var chip = document.createElement('span');
        chip.className = 'ap-dd-cartchip';
        chip.textContent = '−' + Math.floor(((cmpLine - final) * 100) / cmpLine) + '%';
        var price = row.querySelector('.ap-cart__price');
        if (price && price.nextSibling) row.insertBefore(was, price.nextSibling); else row.appendChild(was);
        row.appendChild(chip);
      });
      (cart.cart_level_discount_applications || []).forEach(function (a) { saved += Number(a.total_allocated_amount || 0); });
      // Owner 2026-10-05: "Remove prime week saving bar in cart" (the Checkout+ button's struck compare-at total
      // carries the saving). Clear any row an earlier version added.
      var srow = drawer.querySelector('.ap-dd-cartsave');
      if (srow) srow.remove();
    });
  }
  window.APDDCart = { decorate: decorateCart };

  /* Thin sticky bar (owner 2026-10-04): shown once the board bar and the header have both scrolled out of their
     place in the page, so the two never stack; html.ap-dd-mini-on also offsets Dawn's sticky header below it. */
  function setupMini() {
    var mini = document.querySelector('[data-ap-dd-mini]');
    var bar = document.querySelector('.ap-dd-bar');
    if (!mini || !bar) return;
    if (mini.parentNode !== document.body) document.body.appendChild(mini);
    var root = document.documentElement;
    var header = document.querySelector('.section-header');
    var limit = 0;
    var on = false;
    var queued = false;
    function measure() {
      var r = bar.getBoundingClientRect();
      limit = r.bottom + window.pageYOffset + (header ? header.offsetHeight : 0);
    }
    function update() {
      queued = false;
      var want = window.pageYOffset > limit;
      if (want === on) return;
      on = want;
      root.classList.toggle('ap-dd-mini-on', on);
      mini.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) mini.removeAttribute('tabindex'); else mini.setAttribute('tabindex', '-1');
    }
    function queue() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
    measure();
    update();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', function () { measure(); queue(); });
    window.addEventListener('load', function () { measure(); queue(); });
    setupMiniCart(mini);
  }
  /* Personal sticky bar (owner 2026-10-04, suggestion #8): once the cart has items, the thin bar shows the shopper's
     own gift progress ("$21.00 from your free gift" / "Silver gift added · $X to Gold" / "Gold gift added") and
     opens the cart drawer. Uses the gift script's own progress maths (window.APDDGifts.progress), so the bar and the
     cart's gift card always agree. Gift ladder off or empty cart: the bar stays the event bar. */
  function setupMiniCart(mini) {
    var slot = mini.querySelector('[data-ap-dd-mini-cart]');
    if (!slot) return;
    var hubHref = mini.getAttribute('href');
    var cartHref = shopRoot + 'cart';
    var personal = false;
    var timer = null;
    // Gifts off (Canada, or the gift flag off): show free-shipping progress instead (owner 2026-10-04, Canada parity).
    function paintShip() {
      var at = Number(window.APDD && APDD.shipThreshold) || 0;
      if (!(at > 0)) return;
      window.fetch(shopRoot + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var total = Number(c && c.total_price) || 0;
        if (!(total > 0)) { setMode(false); return; }
        slot.innerHTML = total >= at ? (i18n.miniShipOn || 'Free shipping unlocked · View cart')
          : (i18n.miniShipBelow || '__AMOUNT__ from free shipping').replace('__AMOUNT__', '<b>' + fmtMoney(at - total) + '</b>');
        mini.setAttribute('data-ap-dd-mini-tier', total >= at ? 'ship-on' : 'ship');
        setMode(true);
      }).catch(function () {});
    }
    function paint() {
      timer = null;
      if (!window.APDDGifts || !window.APDDGifts.progress) { paintShip(); return; }
      window.APDDGifts.progress().then(function (g) {
        if (!g || !(g.total > 0)) { setMode(false); return; }
        var amt = function (c) { return '<b>' + fmtMoney(c) + '</b>'; };
        var html = g.tier === 'gold' ? (i18n.miniGold || 'Gold gift added · View cart')
          : g.tier === 'silver' ? (i18n.miniSilver || 'Silver gift added · __AMOUNT__ to Gold').replace('__AMOUNT__', amt(g.toGold))
          : (i18n.miniBelow || '__AMOUNT__ from your free gift').replace('__AMOUNT__', amt(g.toSilver));
        slot.innerHTML = html;
        mini.setAttribute('data-ap-dd-mini-tier', g.tier);
        setMode(true);
      });
    }
    function setMode(on) {
      personal = on;
      slot.hidden = !on;
      mini.classList.toggle('is-cart', on);
      mini.setAttribute('href', on ? cartHref : hubHref);
      mini.setAttribute('data-dd-cta', on ? 'mini_cart' : 'mini');
    }
    function later() { if (timer) window.clearTimeout(timer); timer = window.setTimeout(paint, 350); }
    mini.addEventListener('click', function (e) {
      if (!personal || !window.apCartDrawer || !window.apCartDrawer.open) return;
      e.preventDefault();
      window.apCartDrawer.open();
    });
    document.addEventListener('ap-cart:updated', later);
    later();
  }

  /* Headline count-up (owner 2026-10-04): the "66" in the hero headline is held hidden from first paint
     (html.ap-dd-count-pending, set in snippets/ap-deal-days-head.liquid unless reduced motion), then fades in and
     counts 0 -> 66 once the headline is on screen. The digits' box keeps its final width so "% off" never moves.
     The moving digits are CSS generated content (data-n), so the page TEXT is always the real "66" (kept in a
     visually-hidden copy for screen readers and crawlers) and never "0" or "6666". No JS: a CSS fallback reveals 66 at 3s. */
  function setupCount() {
    var ems = document.querySelectorAll('.ap-dd-hero__title em');
    if (!root.classList.contains('ap-dd-count-pending')) return;
    function run(em, num, target) {
      num.setAttribute('data-n', String(target));
      num.style.minWidth = Math.ceil(num.getBoundingClientRect().width) + 'px';
      num.setAttribute('data-n', '0');
      em.classList.add('is-count-run');
      em.classList.remove('is-count-wait');
      var t0 = null;
      var dur = 1400;
      function frame(now) {
        if (t0 === null) t0 = now;
        var p = Math.min(1, (now - t0) / dur);
        num.setAttribute('data-n', String(Math.round(target * (1 - Math.pow(1 - p, 4)))));
        if (p < 1) window.requestAnimationFrame(frame);
        else em.classList.add('is-count-done');
      }
      window.setTimeout(function () { window.requestAnimationFrame(frame); }, 200);
    }
    Array.prototype.forEach.call(ems, function (em) {
      var walker = document.createTreeWalker(em, NodeFilter.SHOW_TEXT);
      var node;
      var m = null;
      while ((node = walker.nextNode())) { m = /\d+/.exec(node.nodeValue); if (m) break; }
      if (!m) return;
      var target = parseInt(m[0], 10);
      var rest = node.splitText(m.index);
      rest.nodeValue = rest.nodeValue.slice(m[0].length);
      var num = document.createElement('span');
      num.className = 'ap-dd-count';
      num.setAttribute('aria-hidden', 'true');
      num.setAttribute('data-n', '0');
      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      sr.textContent = m[0];
      rest.parentNode.insertBefore(num, rest);
      rest.parentNode.insertBefore(sr, rest);
      em.classList.add('is-count-wait');
      if (!('IntersectionObserver' in window)) { run(em, num, target); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.disconnect();
          run(em, num, target);
        });
      }, { threshold: 0.6 });
      io.observe(em);
    });
    root.classList.remove('ap-dd-count-pending');
  }

  /* Hub FAQ: which questions get opened (once each per page). */
  function setupFaq() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-dd-faq]'), function (d) {
      var sent = false;
      d.addEventListener('toggle', function () {
        if (!d.open || sent) return;
        sent = true;
        track('faq_open', { dd_faq: d.getAttribute('data-dd-faq') });
      });
    });
  }

  /* Bundle Builder spotlight (snippets/ap-deal-days-bundle.liquid, owner 2026-10-06): a 3 / 5 scents toggle that
     fans the scent cards in and flips 15% <-> 20%. Until the shopper touches it, it demos itself while in view, resting on 5
     (a loop, so never under reduced motion). Tiers mirror the builder: 3 scents = 15%, 5 = 20%. */
  function setupBundle() {
    var PCT = { 3: 15, 5: 20 };
    Array.prototype.forEach.call(document.querySelectorAll('[data-dd-bb]'), function (box) {
      var opts = box.querySelectorAll('[data-bb-n]');
      var fig = box.querySelector('[data-bb-pct]');
      var demo = null;
      var touched = false;
      function set(n) {
        box.setAttribute('data-n', n);
        Array.prototype.forEach.call(opts, function (o) { o.setAttribute('aria-checked', o.getAttribute('data-bb-n') === String(n) ? 'true' : 'false'); });
        if (fig) fig.textContent = PCT[n];
      }
      function stopDemo() { if (demo) { window.clearTimeout(demo); demo = null; } }
      // 5 scents is the default (owner 2026-10-06): the demo rests on 5, dips to 3 briefly, then returns to 5.
      function step() {
        var onFive = box.getAttribute('data-n') === '5';
        if (!onFive) set(5);
        demo = window.setTimeout(function () { if (touched) return; set(3); demo = window.setTimeout(step, 1400); }, 3500);
      }
      Array.prototype.forEach.call(opts, function (o) {
        o.addEventListener('click', function () {
          var n = Number(o.getAttribute('data-bb-n'));
          touched = true;
          stopDemo();
          set(n);
          track('bundle_spot_toggle', { dd_scents: n });
        });
      });
      box.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        if (!e.target.closest('[data-bb-n]')) return;
        e.preventDefault();
        var next = box.getAttribute('data-n') === '3' ? 5 : 3;
        touched = true;
        stopDemo();
        set(next);
        box.querySelector('[data-bb-n="' + next + '"]').focus();
      });
      if (reduceMotion || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (touched) return;
          if (en.isIntersecting && !demo) step();
          else if (!en.isIntersecting) { stopDemo(); set(5); }
        });
      }, { threshold: 0.5 }).observe(box);
    });
  }

  function start() {
    setupBundle();
    setupCount();
    setupFaq();
    setupSticky();
    setupBoard();
    setupMini();
    tick();
    if (!timer && !remaining().ended) timer = window.setInterval(tick, 1000);
    watchCountdownView();
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
  window.APDealDays = { tick: tick, remaining: remaining, track: track, names: NAMES };
  window.apDD = { track: track };
  cfg.track = track;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
}());
